<template> 
  <div class="portada-xv" ref="rootRef" aria-label="Portada de XV">

    <!-- IMAGEN PRINCIPAL EN MARCO DE ARCO -->
    <div class="imagen-xv-wrapper" ref="fotoRef">
      <img src="@/assets/WhatsApp Image 2026-10-26 at 11.33.58 AM.jpeg" class="imagen-xv" alt="Foto protagonista" />
    </div>

    <!-- SECCIÓN DE TEXTO UBICADA DEBAJO DE LA IMAGEN -->
    <section class="texto-xv" ref="textoRef">
      <p class="parrafo-presentacion" ref="parrafoRef">
        Un día soñé con este momento y hoy, con el corazón lleno de gratitud y alegría, doy la bienvenida a mis quince años. Es un honor para mí que formes parte de este día que llevaré por siempre con la bendición de Dios y el amor de mi familia.
      </p>
    </section>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'PortadaArley',

  setup() {
    const rootRef = ref(null)
    const fotoRef = ref(null)
    const parrafoRef = ref(null)

    onMounted(async () => {
      await nextTick()

      // TIMELINE ÁGIL GSAP
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: rootRef.value,
          start: 'top 85%',
          once: true
        }
      })

      /* 1. APARICIÓN RÁPIDA DE LA FOTO */
      tl.fromTo(
        fotoRef.value,
        { opacity: 0, scale: 0.95, y: 30, filter: 'blur(4px)' },
        { opacity: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 0.8, ease: 'power2.out' }
      )

      /* 2. PÁRRAFO EMOCIONAL (Aparece casi al mismo tiempo) */
      .fromTo(
        parrafoRef.value,
        { opacity: 0, y: 15 },
        { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out' },
        '-=0.5' // Traslape rápido para que no haya demoras
      )
    })

    return {
      rootRef,
      fotoRef,
      parrafoRef
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Great+Vibes&family=Playfair+Display:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Poppins:wght@400;500;600&display=swap');

/* =========================
   CONTENEDOR PRINCIPAL
========================= */
.portada-xv {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px 60px;
  box-sizing: border-box;

  background-image: 
    linear-gradient(rgba(0, 0, 0, 0.733), rgba(0, 0, 0, 0.605)), 
    url('@/assets/B3D70B5E-2599-498C-923E-4B6C6082F8F9.png');  
  z-index: 1;
  isolation: isolate;
}

/* =========================
   DECORACIÓN EN ESQUINAS
========================= */
.decoracion-esquina {
  position: absolute;
  width: min(42vw, 200px);
  height: auto;
  pointer-events: none;
  z-index: 2;
  opacity: 0.9;
}

.esquina-top-left {
  top: 0;
  left: 0;
}

.esquina-bottom-right {
  bottom: 0;
  right: 0;
  transform: rotate(180deg);
}

/* =========================
   IMAGEN PRINCIPAL EN MARCO DE ARCO
========================= */
.imagen-xv-wrapper {
  position: relative;
  z-index: 5;
  width: min(88vw, 320px);
  height: calc(min(88vw, 320px) * 1.4);
  margin-top: 20px;

  border-radius: 160px 160px 16px 16px;
  overflow: hidden;
  background: #ffffff;
  border: 1.5px solid #cba56b;

  box-shadow:
    0 12px 35px rgba(73, 121, 160, 0.12),
    0 4px 12px rgba(0, 0, 0, 0.06);
}

.imagen-xv {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* =========================
   SECCIÓN DE TEXTO (UBICADA DEBAJO DE LA FOTO)
========================= */
.texto-xv {
  position: relative;
  z-index: 6;
  width: 100%;
  max-width: 580px;
  text-align: center;
  margin-top: 35px;
  padding: 0 10px;
  box-sizing: border-box;
}

/* FRASE SUPERIOR */
.frase-bendicion {
  font-family: 'Playfair Display', serif;
  font-size: clamp(16px, 2.4vw, 20px);
  color: #f3f0f0;
  font-weight: 400;
  line-height: 1.5;
  margin: 0 0 18px;
  text-transform: none;
}

/* NOMBRES DESTACADOS EN AZUL CELESTE */
.nombre-protagonista {
  font-family: 'Playfair Display', serif;
  font-size: clamp(26px, 4.2vw, 36px);
  font-weight: 600;
  color: #5c8ba6;
  text-transform: none;
  line-height: 1.25;
  margin: 10px 0;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.04));
}

/* CONTENEDOR FLEX PARA CRUZ AL LADO DEL NOMBRE COMPLETO */
.nombre-con-cruz {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 10px auto;
}

.nombre-con-cruz .nombre-protagonista {
  margin: 0;
}

/* ÍCONO DE CRUZ FINADO EN TONO CAFÉ ELEGANTE */
.icono-cruz-cafe {
  font-size: 1.2rem;
  color: #8c6d46;
  margin-left: 2px;
}

/* AMPERSAND DORADO EN CURSIVA */
.ampersand {
  display: block;
  margin: 12px auto;
  width: 58px;
  height: auto;
  z-index: 7;
  position: relative;
  filter: brightness(0) saturate(100%) invert(69%) sepia(26%) saturate(693%) hue-rotate(1deg) brightness(93%) contrast(88%);
}

/* PÁRRAFO PRINCIPAL EN CURSIVA ELEGANTE Y MATE */
.parrafo-presentacion {
  font-family: 'Playfair Display', serif;
  font-size: clamp(16px, 2.3vw, 20px);
  font-style: italic;
  color: #f9f9f9;
  line-height: 1.7;
  margin-top:-190px;
  margin: 28px auto 22px;
  max-width: 500px;
  text-transform: none;
}

/* PIE MIS 15 AÑOS EN AZUL CELESTE */
.salmo-ref {
  text-align: center;
  font-family: 'Playfair Display', serif;
  font-size: clamp(28px, 4.5vw, 38px);
  font-weight: 600;
  color: #5c8ba6;
  margin: 15px 0 0;
  text-transform: none;
}

/* ESTILOS ESPECÍFICOS DE PADRINOS */
.seccion-padrinos {
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.separador-padrinos {
  width: 120px;
  height: 1.5px;
  background: linear-gradient(90deg, transparent, #cba56b, transparent);
  margin: 0 auto 20px;
}

.subtitulo-padrinos {
  margin-bottom: 12px;
  font-style: italic;
}

.nombre-padrino {
  font-size: clamp(18px, 3.5vw, 18px);
  margin: 6px 0;
}

.ampersand-padrino {
  width: 46px;
  margin: 8px auto;
}

@media (max-width: 480px) {
  .portada-xv {
    padding: 30px 15px 45px;
  }
  
  .texto-xv {
    margin-top: 25px;
  }

  .icono-cruz-cafe {
    font-size: 1rem;
  }
}
</style>